import './assets/main.css'
import './assets/iframe.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { initializeIframeUtils } from './utils/iframeDetection'

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')

// Initialize iFrame utilities after app is mounted
initializeIframeUtils({
  autoApplyMode: true,
  autoAdjustHeight: false, // Can be enabled if needed
  notifyGameEvents: true,
})
